import type { WSSharedDoc } from "./WSSharedDoc.js"

export const docs = new Map<string, WSSharedDoc>()
